export default __webpack_public_path__ + "static/media/github.ed7e688e.svg";